// Real brand marks — with graceful sizing.
// IA logo is a horizontal gold mark (leaf + IA + INDIAN ALCHEMY).
// PH logo is a horizontal red/gray mark (PH monogram + Platinum hospitality).

export function IAWordmark({ className = "", light = false, height = 40 }) {
  return (
    <img
      src="/ia-logo.png"
      alt="Indian Alchemy"
      style={{ height }}
      className={`w-auto object-contain ${light ? "" : ""} ${className}`}
      draggable={false}
    />
  );
}

export function PHWordmark({ className = "", light = false, height = 44 }) {
  // The PH logo has a white background — on dark surfaces we invert to keep it readable.
  return (
    <img
      src="/ph-logo.jpg"
      alt="Platinum Hospitality"
      style={{ height, background: light ? "#FDFBF6" : "transparent", padding: light ? "4px 8px" : 0, borderRadius: light ? 4 : 0 }}
      className={`w-auto object-contain ${className}`}
      draggable={false}
    />
  );
}
